$(()=>{
  let menuitems = $('.menu-item a');
  $.each(menuitems, (index,item)=>{
    item = $(item);
    let href = item.attr('href').replace("/","");
    if(href && href.startsWith('#') && $(href).eq(0).hasClass('hidden')){
      item.parent().remove()
    }
  })
})



// WEBPACK FOOTER //
// ./js/header.js